module.exports = __webpack_public_path__ + "static/media/gabriel_long.b1d6619a.jpg";